import { useNavigate } from 'react-router-dom';

interface BreadcrumbProps {
  currentPage: string;
  variant?: 'light' | 'dark';
}

export default function Breadcrumb({ currentPage, variant = 'light' }: BreadcrumbProps) {
  const navigate = useNavigate();

  const textColor = variant === 'dark' ? 'text-white/60' : 'text-gray-500';
  const hoverColor = variant === 'dark' ? 'hover:text-white/90' : 'hover:text-gray-700';
  const activeColor = variant === 'dark' ? 'text-white/90' : 'text-gray-700';

  return (
    <div className={`w-full border-b ${variant === 'dark' ? 'border-white/10 bg-black/20' : 'border-gray-200 bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs">
            <button
              onClick={() => navigate('/')}
              className={`flex items-center gap-1.5 ${textColor} ${hoverColor} transition-colors`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-cpu-line text-sm bg-gradient-to-r from-violet-600 to-fuchsia-600 bg-clip-text text-transparent"></i>
              </div>
              <span className="font-bold bg-gradient-to-r from-violet-600 to-fuchsia-600 bg-clip-text text-transparent">openclaw.ai</span>
            </button>
            <i className={`ri-arrow-right-s-line text-sm ${textColor}`}></i>
            <span className={`font-medium ${activeColor}`}>{currentPage}</span>
          </div>
          
          <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full ${variant === 'dark' ? 'bg-white/5 border border-white/10' : 'bg-gradient-to-r from-violet-50 to-fuchsia-50 border border-violet-200'}`}>
            <div className="w-1 h-1 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500 animate-pulse"></div>
            <span className={`text-xs font-bold ${variant === 'dark' ? 'text-white/70' : 'bg-gradient-to-r from-violet-600 to-fuchsia-600 bg-clip-text text-transparent'}`}>
              Powered by OpenClaw
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}